import { PolicyBlock } from "./PolicyBlock";
import privacyPolicyKo from "./privacyPolicyKo";
import privacyPolicyEn from "./privacyPolicyEn";
import termsOfUseKo from "./termsOfUseKo";

export type PolicyType = "privacy" | "terms";

export interface PolicyDocument {
  blocks: PolicyBlock[];
  // 요청한 언어의 원문이 없어 한국어 원문을 대신 보여주는 경우 true.
  isKoreanFallback: boolean;
}

// 법적 효력이 있는 문서이므로 임의로 번역하지 않고, 원문이 있는 언어만 제공한다.
const documents: Record<PolicyType, Record<string, PolicyBlock[]>> = {
  privacy: { ko: privacyPolicyKo, en: privacyPolicyEn },
  terms: { ko: termsOfUseKo },
};

export function getPolicyDocument(
  type: PolicyType,
  language: string
): PolicyDocument {
  const byLanguage = documents[type];
  const languageCode = language.split("-")[0];
  const blocks = byLanguage[languageCode];

  if (blocks !== undefined) {
    return { blocks, isKoreanFallback: false };
  }

  return { blocks: byLanguage.ko, isKoreanFallback: languageCode !== "ko" };
}
